import { marked } from 'marked';

export function isHtmlContent(content) {
  if (!content) return false;
  return /<\/?[a-z][\s\S]*>/i.test(content);
}

export function markdownToHtml(markdown) {
  if (!markdown) return '';
  if (isHtmlContent(markdown)) return markdown;
  // Pre-process __text__ to <u>text</u> before marked parses it
  let processed = markdown.replace(/__(.+?)__/g, '<u>$1</u>');
  return marked.parse(processed);
}

// Convert markdown to HTML optimized for X Articles clipboard paste.
// X Articles strips <h2>/<h3> tags but keeps <strong> and <p>.
// This converts headers into bold paragraphs so they survive the paste.
export function markdownToXArticlesHtml(markdown) {
  if (!markdown) return '';
  const html = markdownToHtml(markdown);
  return html
    .replace(/<h[1-3][^>]*>(.*?)<\/h[1-3]>/gi, '<p><strong>$1</strong></p>')
    .replace(/<h[4-6][^>]*>(.*?)<\/h[4-6]>/gi, '<p><strong>$1</strong></p>');
}

export function stripHtml(html) {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}

export function extractTweetsFromContent(content) {
  if (!content) return [];
  if (isHtmlContent(content)) {
    // Split HTML content by paragraph breaks into individual tweets
    const div = document.createElement('div');
    div.innerHTML = content;
    const blocks = [];
    let current = '';
    for (const node of div.childNodes) {
      const text = (node.textContent || '').trim();
      if (text) {
        current += (current ? '\n' : '') + text;
      } else if (current) {
        blocks.push(current);
        current = '';
      }
    }
    if (current) blocks.push(current);
    return blocks.length > 0 ? blocks : [stripHtml(content)].filter(t => t.trim());
  }
  return content.split('\n\n').filter(t => t.trim());
}
